export const chapter9 = [

    //page 79
    '“How can I thank you both? I‘m forever in your debt”,',
    'Andell laughed, “I‘m sure we‘ll find use for you yet”,',
    'The town elders and guards moved to encircle the three,',
    '“What are you doing we‘ve just saved you, it’s plain to see!”,',
    'Garson was furious, Andell too expressed her frustration,',
    'Sigg tried to cool them down and avoid an altercation,',
    '“Lay the fault on me, I know I have done wrong”,',
    '“Silence now banished one! You no longer belong!”',
    'One of the elders spat back at Sigg -dressed like a bandit,',
    '“Outsiders can never enter Cragknoll the Oath demands it!”,',
    'Teelu pressed her way through the crowd, stopped and thought,',
    '“There is some leeway as we stand now because they have fought”',

    //page 80
    '“You will keep your lives, but will be escorted out of our land”,',
    '“Know that this is a mercy I‘m giving you not a heavy hand”,',
    '“Ridiculous!” Andell yelled as she stomped towards the gate,',
    '“It’s not personal...“ Sigg tried to explain but Garson too was irate,',
    'The group trudged by dead Gobbos out past the wall,',
    'Some elders were embarrassed and grateful but not all,',
    'They kept walking past bodies and spilt blood in the dirt,',
    'Sigg was sore all over and his wounded shoulder really hurt,',
    'There was a muttering as they walked past more and more dead,',
    'Gobbos lay slain along the path as into the forest it now led,',
    'Reaching the ambush site, Gobbo bodies lay strewn everywhere,',
    'One of the elders spoke up “This is just wrong I no longer care!”,',
    '“Without these three we would have had little chance”,',
    'He then stared at the elders with a cold piercing glance,',
    'Garson pointed north “Plenty more dead up that way!”,',
    'One embarrassed elder looked like he had words to say,',
    '“I take it back, I spoke too harshly, ignore this old fool”,',
    'The uptight elder said “I was badly mistaken and cruel”,',
    'Teelu looked relieved “There is a way we can make this right”,',
    '“You three shall become honorary Cragknollians in our sight”,',
    'After some discussion all elders agreed,',
    'Their efforts were truly a legendary deed,',

    //page 81
    'They walked back towards Cragknoll,',
    'The days efforts now taking their toll,',
    'Teelu spoke again “Garson now open to you are the Archives”,',
    '“They are more scrolls therein than can be read in many lives”,',
    'Garson accepted and smiled at the thought,',
    'So much knowledge he had lifelong sought,',
    '“Andell, lets join our two villages with talks and trade”,',
    '“Perhaps together we can avoid mistakes we‘ve made”,',
    '“Thank you Teelu, I‘m sure we can make the region thrive”,',
    '“I have some ideas that I think could help, four or five”,',
    '“Sigg, I‘m sure your family will be happy to see you”,',
    '“No, I made you a promise, this quest I still must do”,',
    '“I‘ll return again one day with all of the artefacts once lost”,',
    '“I will see that I complete this task whatever the cost”,',
    '“Only when this is done I will rest with those that I adore”,',
    'Sigg smiled “Perhaps this world still needs a Scholar of War”,',
    'And that‘s how a banished-one, and two foreigners earned their place ',
    'in the Legends of Cragknoll.',
    'A tribute of remembrance ',
    'By Lorlon Three-Strings Bard of Seventh Court.',
];